<template>
  <!-- 質問動画視聴時 -->
  <div class="video-container" v-if="mode==='question'">
    <div class="video-wrapper">
      <div class="recording-wrapper">
        <video class="video-back" :id="'question-' + index" controls playsinline></video>
        <div class="start-button" v-if="replayStep >= 4">
          <p>
            <span class="mdi mdi-stop -right-4px"></span>
            回答の録画をお願いします。
          </p>
          <span class="desc">再生回数が上限に達しました。</span>
          <span class="desc">「質問({{index + 1}})に回答する」ボタンから</span>
          <span class="desc">回答の録画へ進んでください。</span>
        </div>
        <div class="start-button" @click="startViewing()" v-else-if="!isViewing">
          <p>
            <span class="mdi mdi-play -right-4px"></span>
            視聴を開始
          </p>
          <span class="desc">ここをクリックして質問動画を再生してください。</span>
          <span class="desc">視聴し終わりましたら、「質問({{index + 1}})に回答する」ボタンから</span>
          <span class="desc">回答の録画へ進んでください。</span>
        </div>
      </div>
    </div>
  </div>
  <!-- 質問動画再生以外 -->
  <div v-else>
    <video class="video-back" :id="'question-' + index" controls playsinline></video>
  </div>
</template>

<script>
export default {
  props: ['index', 'mode', 'replayStep', 'video', 'videoMp4', 'answerRecord'],
  data () {
    return {
      // 質問動画再生
      isViewing: false
    }
  },
  mounted () {
    this.videoSetting()
  },
  watch: {
    answerRecord () {
      this.videoSetting()
    },
    index () {
      this.videoSetting()
    }
  },
  methods: {
    videoSetting () {
      this.setVideoSrc()
      this.endedVideo()
    },
    setVideoSrc () {
      this.$nextTick(() => {
        let video = document.getElementById('question-' + this.index)
          const agent = window.navigator.userAgent.toLowerCase();
          // 編集画面との兼ね合いで、ブラウザのクロームの場合はwebm、それ以外はmp4
          if (agent.indexOf('chrome') !== -1 && !navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
            if (typeof(this.video) === 'object') {
              video.src = URL.createObjectURL(this.video)
            } else {
              video.src = this.video
            }
          } else {
            if (typeof(this.videoMp4) === 'object') {
              video.src = URL.createObjectURL(this.videoMp4)
            } else {
              video.src = this.videoMp4
            }
          }
      })
      this.isViewing = false
    },
    /** 質問動画再生 */
    startViewing () {
      this.isViewing = true
      let video = document.getElementById('question-' + this.index)
      video.play()
    },
    endedVideo () {
      if (this.mode === 'question') {
        let video = document.getElementById('question-' + this.index)
        video.addEventListener('ended', (event) => {
          this.$emit('endedVideo')
        })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.video-container {
  padding: 24px;
  text-align: left;
  /deep/ .video-back {
    border-radius: 8px;
  }
  .video-wrapper {
    position: relative;
    width: 100%;
    margin-top: 8px;
    margin-bottom: 24px;
    .question-title {
      margin-bottom: 8px;
    }
    .recording-wrapper {
      position: relative;
      .recording-back {
        width: 100%;
        background: #444;
        border-radius: 8px;
        transform: scale(-1, 1);
      }
      .start-button {
        position: absolute;
        top: 0;
        cursor: pointer;
        color: white;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 24px;
        transition: 0.5s;
        opacity: 0.9;
        p {
          font-size: 18px;
          transition: 0.5s;
        }
        .desc {
          font-size: 13px;
          transition: 0.5s;
        }
      }
      .start-button:hover {
        p {
          font-size: 24px;
        }
        .desc {
          font-size: 16px;
          transition: 0.5s;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/VideoView/organisms/RecordingVideoTag.vue